import type { EmsComponents, NormalizedNullableResponse } from '../../api/ems';
import { normalizeLocation } from './location';
import type { Location } from './location';

export type IncidentListItemWire = EmsComponents['schemas']['PortalIncidentListItem'];
export type IncidentListItem = Omit<
  NormalizedNullableResponse<IncidentListItemWire>,
  'currentLocation'
> & {
  currentLocation: Location | null;
};
export type IncidentListAgencyView = IncidentListItem['agencyViews'][number];

export function normalizeIncidentListItem(item: IncidentListItemWire): IncidentListItem {
  return {
    ...item,
    label: item.label ?? null,
    callSign: item.callSign ?? null,
    ateMessage: item.ateMessage ?? null,
    closedAtUtc: item.closedAtUtc ?? null,
    currentLocation: item.currentLocation == null ? null : normalizeLocation(item.currentLocation),
    involvedAgencies: item.involvedAgencies.map((agency) => ({
      ...agency,
      position: agency.position ?? null,
      invitedBy: agency.invitedBy ?? null,
    })),
  };
}
